import { Component, OnInit } from '@angular/core';
import { GeneralTeacherComponent } from '../../General/gt.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-t-binary',
  templateUrl: './t-binary.component.html',
  styleUrls: ['./t-binary.component.css']
})
export class TBinaryComponent extends GeneralTeacherComponent {

  searchType: string = "binary";
  elementType: string = "number";
  requestedElement: any;
  fixedElements: boolean = false;
  elements: any[] = [];
  range: number[] = [0, 500];
  distribution: string = "even";
  count: number;
  elementS = undefined;

  limitRange: boolean = false;
  computeMiddle: boolean = false;
  text = undefined;

  limitedRange = [];

  constructor(protected topicService: TopicService, protected activatedRoute: ActivatedRoute, protected http: HttpClient) {
    super(topicService, activatedRoute);
    this.loadText();
  }

  reset() {
    super.reset();
    this.title = this.get("binarySearchTitle");
    this.searchType = "binary";
    this.elementType = "number";
    this.requestedElement = undefined;
    this.fixedElements = false;
    this.elements = [];
    this.elementS = undefined;
    this.range = [0, 500];
    this.distribution = "even";
    this.count = undefined;

    this.limitRange = false;
    this.computeMiddle = false;
  }

  /** sets information based on configuration */
  setInformationWithConfiguration() {
    super.setInformationWithConfiguration();
    this.searchType = this.configuration.typespecifics.type;
    this.elementType = this.configuration.typespecifics.elementType;
    this.requestedElement = this.configuration.typespecifics.requestedElement;
    this.fixedElements = true;
    this.elements = this.configuration.typespecifics.elements;

    this.elementS = this.elements.toString();
    this.limitRange = this.configuration.typespecifics.limitRange;
  }

  /** loads the text to generate words from */
  loadText(): Promise<any> {
    let textFile = "./assets/text_" + this.topicService.getLanguage() + ".txt";
    let self = this;
    return new Promise((resolve, reject) => {
      this.http
        .get<string>(textFile)
        .subscribe(response => {
          self.text = response;
          resolve(true);
        })
    })
  }

  /** recompute hte element */
  changeElements() {
    this.elementS = this.elementS.trim();
    this.elements = this.elementS.split(",");
    if (this.requestedElement && !this.elements.includes(this.requestedElement.toString())) {
      this.elements.push(this.requestedElement);
      this.elements = this.elements.sort();
    }
    if (this.elementType == 'number') {
      this.elements = this.elements.map(v => +v);
      this.elements = this.elements.sort((a, b) => +a -+b);
    }
    this.elementS = this.elements.toString();

  }


  /** automatically generate elements */
  generateElements() {
    if (this.requestedElement) {
      this.requestedElement = this.requestedElement.toString().trim();
    }
    if (this.elementType == 'number') {
      this.requestedElement = Math.floor(+this.requestedElement);
    }
    if (this.definitionForm.valid && !this.fixedElements) {
      this.elements = [];
      if (this.elementType == "number") {
        this.requestedElement = +this.requestedElement;
      }
      this.computeElements();
    }
  }

  generateDefinition(): any {
    let definition: any = {};
    definition.typespecifics = {};
    definition.title = this.title;
    definition.type = this.type;
    definition.description = this.description;
    definition.image = "./assets/images/search_white.png";
    if (this.id == undefined || this.id == null) {
      definition.id = this.topicService.getMaxId(this.examId) + 1;
    } else {
      definition.id = this.id;
    }
    this.id = definition.id;
    definition.key = "searchAndOrder%".concat(this.type, "%");
    if (this.examId > -1) {
      definition.key = definition.key.concat("exam%", this.examId.toString(), "%");
    }
    definition.key = definition.key.concat(this.requestedElement, "%", this.searchType);
    definition.typespecifics.requestedElement = this.requestedElement;
    definition.typespecifics.elements = this.elements;
    definition.key = definition.key.concat("%", this.elements.toString());
    definition.typespecifics.elementType = this.elementType;
    definition.typespecifics.type = this.searchType;
    definition.typespecifics.limitRange = this.limitRange;
    definition.typespecifics.computeMiddle = this.computeMiddle;
    definition.level = (this.searchType != "binary" ? 3 : (this.limitRange || this.computeMiddle ? 1 : 2));
    return definition;
  }

  /** computes the elements, inserts the requested one and sorts them increasingly */
  computeElements() {
    this.elements.push(this.requestedElement);
    if (this.elementType == "number") {
      if (!this.fixedElements) {
        if (this.distribution == "even") {
          let i = 0;
          while (i < this.count) {
            let elem = Math.floor(Math.random() * (this.range[1] - this.range[0]) + this.range[0]);
            while (this.elements.includes(elem)) {
              elem = Math.floor(Math.random() * (this.range[1] - this.range[0]) + this.range[0]);
            }
            this.elements.push(elem);
            i++;
          }
        } else {
          let clusters = Math.ceil(this.count / 5);
          for (let i = 0; i < clusters; i++) {
            let center = Math.floor(Math.random() * (this.range[1] - this.range[0]) + this.range[0]);
            while (this.elements.filter(v => center - v < 10).length > 2 && this.elements.includes(center)) {
              center = Math.floor(Math.random() * (this.range[1] - this.range[0]) + this.range[0]);
            }
            this.elements.push(center);
            let min = Math.max(center - 5, this.range[0]);
            let max = Math.min(center + 5, this.range[1]);
            let end = this.count - this.elements.length;
            for (let j = 0; j < Math.min(4, end); j++) {
              let elem = Math.floor(Math.random() * (max - min) + min);
              while (this.elements.includes(elem)) {
                elem = Math.floor(Math.random() * (max - min) + min);
              }
              this.elements.push(elem);
            }
          }
        }
      }

      this.elements = Array.from(new Set(this.elements));
      this.elements.sort();
      if (this.elementType == "number") {
        this.elements.sort((a, b) => (+a - +b));
      }
    } else { // elementType== 'string'
      this.computeElementsText(this.text.text);

    }
  }


  /** get random elements based on text */
  computeElementsText(text: string) {
    let words = text.replace(/[.,!:*+?^${}()|[\]\\]/g, "").split(" ").filter(v => v.length > 2).filter(v => v.length < 7);
    words = Array.from(new Set(words));
    this.elements.push(this.requestedElement);
    while (this.elements.length <= this.count && words.length > 0) {
      let index = Math.ceil(Math.random() * words.length - 1);
      this.elements.push(words[index]);
      words.splice(index, 1);

    }
    this.elements = Array.from(new Set(this.elements.map(v => v.toUpperCase())));
    this.requestedElement = this.requestedElement.toUpperCase();
    this.elements.sort();
  }

  generate() {
    this.elementType = this.searchType != 'linear'?(Math.random() > 0.5 ? "number" : "string"): "number";
    this.fixedElements = false;
    this.count = Math.floor((Math.random() * 30) + 20);
    this.distribution = Math.random() > 0.5 ? "even" : "clustered";
    this.range[0] = Math.floor(Math.random() * 100);
    this.range[1] = Math.floor((Math.random() * 200) + (this.distribution == 'even' ? 2 * this.count : 5 * this.count) + this.range[0]);
    if (this.elementType == "number") {
      this.requestedElement = Math.ceil(Math.random() * (this.range[1] - this.range[0])) + this.range[0];
    } else {
      let words = this.text.text.replace(/[.,!:*+?^${}()|[\]\\]/g, "").split(" ").filter(v => v.length > 2).filter(v => v.length < 7);
      words = Array.from(new Set(words));
      this.requestedElement = words[Math.floor(Math.random() * words.length)];
    }
    this.elements = [];
    this.computeElements();

    this.limitRange = Math.random() > 0.5;
    this.computeMiddle = Math.random() > 0.5;
  }



}
